import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { API_URL } from '../config/api';
import SEO from '../components/SEO';
import './Information.css';
import './Gdpr.css';

const GuidelinesReviews = () => {
  const { t, i18n } = useTranslation();
  const [contentFi, setContentFi] = useState('');
  const [contentEn, setContentEn] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fetchContent = async () => {
      if (!API_URL) {
        setError(t('guidelinesReviews.loadError') || 'Could not load content.');
        setLoading(false);
        return;
      }
      try {
        const url = `${API_URL.replace(/\/$/, '')}/settings/guidelines-reviews`;
        const response = await axios.get(url);
        if (cancelled) return;
        const data = response?.data || {};
        setContentFi(data.contentFi ?? '');
        setContentEn(data.contentEn ?? '');
        setError(null);
      } catch (err) {
        if (cancelled) return;
        console.error('Error fetching guidelines for reviews:', err);
        const message = err.response?.data?.message || err.message || (t('guidelinesReviews.loadError') || 'Could not load content.');
        setError(message);
        setContentFi('');
        setContentEn('');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchContent();
    return () => { cancelled = true; };
  }, [t]);

  const isFi = i18n.language && i18n.language.startsWith('fi');
  const content = isFi ? contentFi : contentEn;

  const blocks = (content || '')
    .split(/\n\n+/)
    .map((block) => block.trim())
    .filter(Boolean);

  if (loading) {
    return (
      <div className="information-container gdpr-page">
        <div className="container">
          <p>{t('admin.loading') || 'Loading...'}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="information-container gdpr-page">
        <div className="container">
          <p className="error-message">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="information-container gdpr-page">
      <SEO
        title={t('guidelinesReviews.title') || 'Guidelines for reviews'}
        description={t('guidelinesReviews.description') || 'Guidelines for writing reviews on our platform.'}
        path="/guidelines-reviews"
      />
      <div className="container">
        <h1 className="gdpr-title">{t('guidelinesReviews.title') || 'Guidelines for reviews'}</h1>
        <div className="information-content gdpr-content">
          <div className="gdpr-body">
            {blocks.length === 0 ? (
              <p className="gdpr-paragraph">{t('guidelinesReviews.empty') || 'Guidelines have not been published yet.'}</p>
            ) : (
              blocks.map((block, i) => {
                if (block.startsWith('## ')) {
                  return (
                    <h2 key={i} className="gdpr-section-title">
                      {block.slice(3).trim()}
                    </h2>
                  );
                }
                return (
                  <p key={i} className="gdpr-paragraph">
                    {block}
                  </p>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuidelinesReviews;
